import React from 'react';
import PropTypes from 'prop-types';

const headingStyle = {
  margin: 0,
  color: '#000',
  fontWeight: 700,
};

const bodyStyle = {
  marginTop: '0.75rem',
  marginBottom: 0,
  color: '#000',
};

const NoResultsMessage = ({ heading, message }) => (
  <div className="mar-1-t" role="alert">
    <p style={headingStyle}>{heading}</p>
    <p style={bodyStyle}>{message}</p>
  </div>
);

NoResultsMessage.propTypes = {
  heading: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default NoResultsMessage;
